var indentStyle = {"indentZero":"EEVET","indentOne":"cflYt","indentTwo":"_69Cpt","indentThree":"_4u4im","indentFour":"FM7uI","indentFive":"t5Qb4","indentSix":"jL2On"};

export { indentStyle as i };
//# sourceMappingURL=indentation-01d0a32d.js.map
